const formatFullName = (name: { prefix?: string | null; last: string; first: string } | undefined | null) => {
  if (!name) return '';
  const { prefix, first, last } = name;
  const toString = (value?: string | null) => value ?? '';
  const fullName = `${last} ${first}`;
  return `${toString(prefix)} ${fullName}`.trim();
};

export default formatFullName;
